/**
 * Bottom-anchored length that also clears the device safe-area inset.
 *
 * Every element in the in-play pinned footer stack (sticky-footer ad banner →
 * submit CTA → picks scroll padding) is measured from the same origin, so they
 * must all account for the inset the same way. Mixing a `calc(... + env())`
 * position with a px-only reserved offset leaves the stack misaligned by
 * exactly the inset on devices where it is non-zero (DKPLAT-694).
 */
export const withSafeAreaBottom = (px: number) => `calc(${px}px + env(safe-area-inset-bottom))`;
